export const TEACHER_LOW_BITRATE_QUALITY = "TEACHER_LOW_BITRATE_QUALITY";
export const TEACHER_STREAMLABS_ERROR = "TEACHER_STREAMLABS_ERROR";
